module.exports = __webpack_public_path__ + "img/YimMenu.eb27d29d.png";